// App.jsx

import "../assets/styles/App.css";
import Header from '../components/Header';
import { Outlet } from 'react-router-dom';
import styled from "styled-components";
import ErrorBoundary from "../components/ErrorBoundary";
import { useState } from "react";
import { ThemeProvider } from '../stores/ThemeContext';
import { getTheme } from '../assets/styles/Theme';
import BackgroundImageLight from "../assets/img/LIGHT-BG.png";
import BackgroundImageDark from "../assets/img/DARK-BG.jpg";
import SidebarComponent from '../components/Sidebar';
import MobileHeader from "../components/mobile/MobileHeader/MobileHeader";
import CookieBanner from "../components/CookieBanner";
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n/i18n';
import CategoryTabs from "../components/CategoryTabs";
import { useGeneralInfoStore } from "../stores/GeneralInfoStore";
import LangflowChatWidget from "../components/componets/langflow/LangflowChatWidget";

const FlexMain = styled.div`
  display: flex;
  direction: ltr;
`;

const StyledMain = styled('div')(({ theme }) => `
  position: relative;
  min-height: 100vh;
  width: -webkit-fill-available;
  width: -moz-available;
  padding-left: 80px;
  background-color: ${theme.palette.background.paper || 'defaultColor'};
  background-image: url(${theme.palette.mode === 'dark' ? BackgroundImageDark : BackgroundImageLight});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-attachment: fixed;
  z-index: 0;
  @media (max-width: 800px) {
    min-height: auto;
    height: auto;
    padding-left: 0;
    padding-top: 3rem;
  }
`);

const App = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 800);
  const theme = getTheme('light');
  const { category, activeTab } = useGeneralInfoStore();
  const flowId = process.env.REACT_APP_LANGFLOW_FLOW_ID;
  const hostUrl = process.env.REACT_APP_LANGFLOW_HOST_URL;

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <ErrorBoundary>
          <FlexMain>
            <SidebarComponent isSidebarOpen={isSidebarOpen} />
            {!isSidebarOpen && <MobileHeader />}
            <StyledMain>
              {isSidebarOpen && <Header />}
              {activeTab && <CategoryTabs />}
              <Outlet />
            </StyledMain>
          </FlexMain>
        </ErrorBoundary>
        {flowId || hostUrl ? (
          <LangflowChatWidget />
        ) : (<></>
        )}
        <CookieBanner />
      </ThemeProvider>
    </I18nextProvider>

  );
};

export default App;
